import collections from "@api/collections";
import React from "react";
import { connect } from "react-redux";
import { Tab } from "semantic-ui-react";
import CommentsTab from "./CommentsTab";
import SimpleTab from "./SimpleTab";
import Transactions from "./Transactions";

const SecondaryTabs = (props) => {
  let panes = [
    {
      menuItem: "Transactions",
      pane: (
        <Tab.Pane>
          <Transactions />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Comments",
      pane: (
        <Tab.Pane>
          <CommentsTab />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Events",
      pane: (
        <Tab.Pane>
          <SimpleTab onLoad={collections.getEvents} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Tickets @ EGM",
      pane: (
        <Tab.Pane>
          <SimpleTab onLoad={collections.getTickets} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Tickets Redeemed @ Kiosk/CD",
      pane: (
        <Tab.Pane>
          <SimpleTab onLoad={collections.getTicketsInKiosk} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <Tab
      renderActiveOnly={false}
      panes={panes}
      className="flex-stretch gs-flex-container-vertical h-100"
    />
  );
};
const mapStateToProps = (state) => {
  return {
    modal: state.collectionBreakdownModal,
  };
};

export default connect(mapStateToProps)(SecondaryTabs);
